import {useEffect} from 'react'
import {useParams} from 'react-router-dom'

import useAlertModalAtom from 'shared/model/useAlertModalAtom'
import useFetch from 'shared/model/useFetch'
import useRoleCookie from 'shared/model/useRoleCookie'
import getApiRolePath from 'shared/utils/getApiRolePath'

const usePutAccountParticipationTicketCollect = () => {
	const {idx} = useParams()
	const [userRole] = useRoleCookie()

	const [fetchResult, fetchRequest] = useFetch()
	const [, setAlert] = useAlertModalAtom()

	const request = (ticketIdx) => {
		const rolePath = getApiRolePath(userRole)
		let url = `/${rolePath}/account/${idx}/participate-ticket/${ticketIdx}`

		fetchRequest('DELETE', url)
	}

	useEffect(() => {
		switch (fetchResult?.statusCode) {
			case 200:
				window.location.reload()
				break
			case 400:
				if (fetchResult?.data?.error_code === 'account_idx')
					setAlert('사용자 idx를 확인해 주세요.')
				else if (fetchResult?.data?.error_code === 'participate_ticket_idx')
					setAlert('참가권 idx를 확인해 주세요.')
				else if (fetchResult?.data?.error_code === 1)
					setAlert('보유량보다 더 많이 회수할 수 없습니다.')
				break
			case 404:
				if (fetchResult?.data?.error_code === 1)
					setAlert('사용자 데이터가 존재하지 않습니다.')
				else if (fetchResult?.data?.error_code === 2)
					setAlert('참가권 데이터가 존재하지 않습니다.')
				break
			case 409:
				if (fetchResult?.data?.error_code === 1)
					setAlert('이미 사용되었거나 회수된 참가권 입니다.')
				break
		}
	}, [fetchResult])

	return [request]
}

export default usePutAccountParticipationTicketCollect
